
<template>
    <b-container class="pb-5">
        <div v-if="selectedDate==null">
            <b-row class="mb-5">
                <b-col>
                    <full-calendar defaultView="month" :events="events" @event-selected="eventSelected" @day-click="selectEvents"></full-calendar>
                </b-col>
            </b-row>
        </div>
        <div v-else>
            <b-row class="mt-5">
                <b-col>
                    <div class="events-wrapper">
                        <h4>Available Excursions</h4>
                        <template v-if="selectedEvents.length > 0">
                            <div class="events" v-for="(event, index) in selectedEvents"
                                :key="index">
                                <div class="event-title mb-2" @click="eventInfo(event)">{{event.title}}</div>
                            </div>
                        </template> 
                    </div>    
                </b-col>
                <b-col class="text-right">
                    <button @click="selectBack">Back</button>
                </b-col>
            </b-row>
            <Events :selectedEvent="selectedEvent" v-if="selectedEvent.title" />    
        </div>
    </b-container>
</template>

<script>
// @ is an alias to /src
import { FullCalendar } from 'vue-full-calendar'
import 'fullcalendar/dist/fullcalendar.css'
import Events from './Events'
import axios from 'axios'

export default {
    name: 'booking-events',
    components: {
        FullCalendar,
        Events
    },
    data () {
        return {
            selectedEvents: [],
            selectedDate: null,
            events: [
                {
                    id: 1,
                    title  : 'event1',
                    start  : '2019-11-01',
                },
                {
                    id: 2,
                    title  : 'event2',
                    start  : '2019-11-05',
                    end    : '2019-11-07',
                },
                {
                    id: 3,
                    title  : 'event3',
                    start  : '2019-11-09T12:30:00',
                    allDay : false,
                },
                {
                    id: 4,
                    title  : 'event4',
                    start  : '2019-11-09T12:30:00',
                    allDay : false,
                },
                {
                    id: 5,
                    title  : 'event5',
                    start  : '2019-11-15'
                }
            ],
            selectedEvent: {},
        }
    },

    methods: {
    
        eventInfo(event) {
            this.selectedEvent = event
        },

        eventSelected(event) {
            this.selectedEvent = event
            this.selectEvents(event.start)
        },
        selectEvents(day) {
            this.selectedDate = day
            var date = new Date(this.selectedDate);
            this.selectedEvents = this.events.filter(data => {
                var date1 = new Date(data.start);
                return date1.toLocaleDateString() === date.toLocaleDateString()
            });
        },
        selectBack(){
            this.selectedDate = null
            this.selectedEvent = {}
        }
    }
}
</script>

<style lang="scss">
    .events-wrapper {
        text-align: left;

        .event-title {
            cursor: pointer;
            text-transform: capitalize;
            display: inline-block;
        }
    }
</style>
